import {
  CompanyPreferencesModel,
  PermalinkAccessEnum,
} from '../../libs/shared/core/src/models/api/companyPreferencesModel';
import {MessageModel} from '../../libs/shared/core/src/models/api/messageModel';
import {postAsync} from '../../libs/shared/core/src/services/http/http';
import {buildConversationPublicLink} from '../../src/helpers/models/conversationHelpers';
import {buildMessagePublicLink} from '../../src/helpers/models/messageHelpers';
import {ConversationBaseModel} from '../../src/models/api/conversationModel';

export async function generateConversationPermalink(
  conversation: ConversationBaseModel,
  host: string,
  preferences: CompanyPreferencesModel,
): Promise<string> {
  if (preferences.permalinkAccess !== PermalinkAccessEnum.ALL_TEAMMATES) {
    return buildConversationPublicLink(host, conversation);
  }

  const response = await postAsync(`${conversation.url}/permalink`);

  return response.permalink;
}

export async function generateMessagePermalink(
  message: MessageModel,
  host: string,
  preferences: CompanyPreferencesModel,
): Promise<string> {
  if (preferences.permalinkAccess !== PermalinkAccessEnum.ALL_TEAMMATES) {
    return buildMessagePublicLink(host, message);
  }

  const response = await postAsync(`${message.url}/permalink`);

  return response.permalink;
}

export function buildCopyLinkDataTestId(resourceName: string, preferences: CompanyPreferencesModel) {
  return preferences.permalinkAccess === PermalinkAccessEnum.ALL_TEAMMATES
    ? `${resourceName}-link-allteammates`
    : `${resourceName}-link-participantsonly`;
}
